// Simple equality but with a twist
// Sometimes null and a certain value like "unknown" are considered equal
// So areStringsEqual("unknown", null, "unknown") should be true
export const areEqual = <T extends string | boolean>(
  strA: T | null,
  strB: T | null,
  defaultValueIfNull: T
) => {
  return (strA ?? defaultValueIfNull) === (strB ?? defaultValueIfNull);
};

export const areArrayValuesEqual = <T extends string | number>(
  arrA: T[] | null,
  arrB: T[] | null
) => {
  const aIsEmptyOrNull = arrA == null || arrA.length === 0;
  const bIsEmptyOrNull = arrB == null || arrB.length === 0;
  if (aIsEmptyOrNull && bIsEmptyOrNull) return true;
  if (aIsEmptyOrNull || bIsEmptyOrNull) return false;

  return [...arrA].sort().join(",") === [...arrB].sort().join(",");
};
